import { useAbExperimentBucket } from 'hooks/abExperiment/useAbExperimentBucket';
import {
  orgDashboardCartRoute,
  orgDashboardCheckoutCartRoute,
} from 'modules/orgDashboard/routing/orgDashboard.routes';

export function useABExperimentOrgDashboardCartRoute() {
  const [bucket] = useAbExperimentBucket('OLD_CART_MIGRATION');
  const singleScreenPaymentFlowEnabled = bucket === 'NEW';

  return singleScreenPaymentFlowEnabled
    ? orgDashboardCheckoutCartRoute
    : orgDashboardCartRoute;
}
